const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26.133 22.933c-2.133-2.133-7.467-2.133-9.6 0V9.601c2.133-2.135 7.467-2.135 9.6 0zm-10.667 0c-2.133-2.133-7.466-2.133-9.6 0V9.601c2.134-2.135 7.467-2.135 9.6 0zM16 0C7.163 0 0 7.163 0 16s7.163 16 16 16c8.836 0 16-7.163 16-16 0-8.836-7.164-16-16-16z"
});

const SvgLearn = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#6fdcf8",
    fillRule: "evenodd",
    height: 32,
    width: 32,
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLearn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/learn.74eccb92.svg";
export { ForwardRef as ReactComponent };